/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  UtxFiatDepositGetFiatDepositMethodsParams
} from './schema'



export const utxFiatDepositGetFiatDepositMethods = (
    params: UtxFiatDepositGetFiatDepositMethodsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/fiat-deposit/methods`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxFiatDepositGetFiatDepositMethodsQueryKey = (params: UtxFiatDepositGetFiatDepositMethodsParams,) => [`/fiat-deposit/methods`, ...(params ? [params]: [])];

    
export type UtxFiatDepositGetFiatDepositMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof utxFiatDepositGetFiatDepositMethods>>>
export type UtxFiatDepositGetFiatDepositMethodsQueryError = AxiosError<unknown>

export const useUtxFiatDepositGetFiatDepositMethods = <TData = Awaited<ReturnType<typeof utxFiatDepositGetFiatDepositMethods>>, TError = AxiosError<unknown>>(
 params: UtxFiatDepositGetFiatDepositMethodsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxFiatDepositGetFiatDepositMethods>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxFiatDepositGetFiatDepositMethodsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxFiatDepositGetFiatDepositMethods>>> = ({ signal }) => utxFiatDepositGetFiatDepositMethods(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxFiatDepositGetFiatDepositMethods>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

